// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"295":"864f3bb6","545":"c9e4a297","569":"84700ddc","617":"4b90f7d9","618":"c5da3905","641":"23052763","891":"2f842947"}[chunkId] + ".chunk.css";
};